import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { LightbulbIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

import { sizeConfig } from './constants'
import * as Styles from './styles'

const SizingIssuesAlert = ({ size = 'small' }) => {
  const { t } = useTranslation()
  const { iconSize, textType } = sizeConfig[size]

  return (
    <Styles.Container size={size}>
      <LightbulbIcon data-testid="sizing-alert-icon" size={iconSize} />
      <Text type={textType}>
        {t('Redúcelos automáticamente con nuestro')}{' '}
        <Styles.WidgetLink as={Link} to={routes.configurationPage.extras.sizingWidget}>
          {t('Widget de tallas')}
        </Styles.WidgetLink>
      </Text>
    </Styles.Container>
  )
}

export default SizingIssuesAlert
